<div class="switch-div" [ngClass]="{'is-active': isActive(), 'is-disabled': disabled}" (click)="toggle()"></div>
